export default {
  meta: {
    label: 'Français'
  },
  data: {
    'fr-FR': {
      97: [
        ['⚓️', 'ancre'],
        ['🦅', 'aigle'],
        ['🐝', 'abeille'],
        ['🌳', 'arbre'],
        ['🕷️', 'araignée'],
        ['💡', 'ampoule'],
        ['🌈', 'arc-en-ciel'],
        ['🍍', 'ananas'],
        ['🍆', 'aubergine'],
        ['🥑', 'avocat']
      ],
      98: [
        ['🍌', 'banane'],
        ['👶', 'bébé'],
        ['🎈', 'ballon'],
        ['👄', 'bouche'],
        ['📫', 'boites aux lettres'],
        ['🥦', 'broccoli']
      ],
      99: [
        ['🐶', 'chien'],
        ['🐱', 'chat'],
        ['🐈', 'chat'],
        ['🦇', 'chauve-souris'],
        ['🛶', 'canöé'],
        ['🤠', 'cow-boy'],
        ['🦌', 'cerf'],
        ['🏒', 'crosse'],
        ['🍦', 'crème glacée'],
        ['🔪', 'couteau'],
        ['🔑', 'clé'],
        ['🥐', 'croissant'],
        ['🐊', 'crocodile'],
        ['❤️', 'coeur'],
        ['🐞', 'cocinelle'],
        ['🥒', 'concombre'],
        ['🥕', 'carotte']
      ],
      100: [
        ['💃', 'danseuse'],
        ['🦃', 'dinde'],
        ['🐬', 'dauphin'],
        ['🦷', 'dent'],
        ['🐲', 'dragon'],
        ['🍩', 'donut']
      ],
      101: [
        ['👣', 'emprunte de pas'],
        ['🧣', 'écharpe'],
        ['✉️', 'enveloppe'],
        ['⭐', 'étoile'],
        ['🌽', 'épi de maïs'],
        ['🐘', 'éléphant'],
        ['🐿️', 'écureuil']
      ],
      102: [
        ['🇫🇷', 'france'],
        ['🍟', 'frites'],
        ['👻', 'fantôme'],
        ['🚀', 'fusée'],
        ['🔥', 'feu'],
        ['🐜', 'fourmi'],
        ['🍓', 'fraise'],
        ['🧀', 'fromage']
      ],
      103: [
        ['🦍', 'gorille'],
        ['🐸', 'grenouille'],
        ['🧤', 'gant'],
        ['🎸', 'guitare'],
        ['🦒', 'giraffe']
      ],
      104: [
        ['🐹', 'hamster'],
        ['🌺', 'hibiscus'],
        ['🚁', 'hélicoptère'],
        ['🌭', 'hot-dog'],
        ['🦔', 'hérisson'],
        ['🦉', 'hibou'],
        ['🦛', 'hippopotame']
      ],
      105: [['🏝️', 'île'], ['🖨️', 'imprimante']],
      106: [['🤹🏼‍♀️', 'jongleur'], ['👖', 'jeans'], ['📰', 'journal']],
      107: [['🐨', 'koala'], ['👘', 'kimono'], ['🥝', 'kiwi']],
      108: [
        ['🦁', 'lion'],
        ['🦎', 'lézard'],
        ['🐆', 'léopard'],
        ['🐇', 'lapin'],
        ['🦄', 'licorne'],
        ['🕶️', 'lunettes de soleil'],
        ['🐺', 'loup'],
        ['📚', 'livres'],
        ['🔍', 'loupe']
      ],
      109: [
        ['🍈', 'melon'],
        ['🚶', 'marche'],
        ['⌚', 'montre'],
        ['🎮', 'manette'],
        ['🍯', 'miel'],
        ['🎤', 'microphone'],
        ['🏍️', 'moto'],
        ['🥭', 'mangue']
      ],
      110: [
        ['👃', 'nez'],
        ['🎶', 'note de musique'],
        ['☁️', 'nuage'],
        ['🧸', 'nounours']
      ],
      111: [
        ['👌', 'ok'],
        ['🖥️', 'ordinateur'],
        ['🦴', 'os'],
        ['🍊', 'orange'],
        ['🥚', 'oeuf']
      ],
      112: [
        ['🥞', 'pancake'],
        ['🍐', 'poire'],
        ['🥘', 'pot'],
        ['🍎', 'pomme'],
        ['☂️', 'parapluie'],
        ['🐙', 'poulpe'],
        ['🍉', 'pastèque'],
        ['🐼', 'panda'],
        ['🦋', 'papillon'],
        ['🐟', 'poisson'],
        ['🦜', 'perroquet'],
        ['🍑', 'pêche'],
        ['🌶️', 'piment']
      ],
      113: ['🇶🇦'],
      114: [
        ['🤖', 'robot'],
        ['🦊', 'renard'],
        ['🌹', 'rose'],
        ['🦏', 'rhinocéros'],
        ['🐀', 'rat'],
        ['🦈', 'requin']
      ],
      115: [
        ['🐍', 'serpent'],
        ['🥗', 'salade'],
        ['🍣', 'sushi'],
        ['🌲', 'sapin'],
        ['🌞', 'soleil'],
        ['🦂', 'scorpion'],
        ['🍭', 'sucette'],
        ['🐁', 'souris']
      ],
      116: [
        ['🐯', 'tigre'],
        ['🌮', 'tacos'],
        ['🐅', 'tigre'],
        ['🌪', 'tornade'],
        ['☎️', 'téléphone'],
        ['🛴', 'trotinette'],
        ['📺', 'télé'],
        ['🍀', 'trèfle à quatre feuilles'],
        ['🌷', 'tulipe'],
        ['🐢', 'tortue'],
        ['🦖', 't-rex'],
        ['🕸️', "toile d'araignée"],
        ['🍅', 'tomate'],
        ['🥔', 'patate']
      ],
      117: ['🏭'],
      118: [
        ['🎻', 'violon'],
        ['🏐', 'ballon de volley'],
        ['🌋', 'volcan'],
        ['🌊', 'vague'],
        ['🚲', 'vélo'],
        ['🚗', 'voiture'],
        ['🐄', 'vache']
      ],
      119: [],
      120: [],
      121: [['💴', 'yen'], '☯️', '👀'],
      122: [
        ['⚡️', 'zap'],
        ['🇿🇼', 'Zimbabwe'],
        ['🧟', 'zombie'],
        ['🦓', 'zèbre']
      ]
    }
  }
};
